"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const bodyParts_1 = require("../../bodyParts");
const BodyParts_1 = require("../shared/BodyParts");
const female_front_png_1 = __importDefault(require("./female-front.png"));
const FemaleImage_1 = __importDefault(require("./FemaleImage"));
const paths = {
    [bodyParts_1.BodyPartsFront.RightUpperSkull]: {
        d: `M310.1,60.668c-24.6,0.8-41.7,14.2-48.1,35.4c-1.1,3.8-1.9,8-2.5,12.5l0,0c0,0.2,0,0.4-0.1,0.6c15,2,32.8,3.1,51.8,3.1
    c0.1,0,0.2,0,0.3,0v-51.6C311.1,60.668,310.6,60.668,310.1,60.668z`,
        "aria-label": "Front right upper skull",
    },
    [bodyParts_1.BodyPartsFront.LeftUpperSkull]: {
        d: `M364,109.068c0-0.2,0-0.4-0.1-0.7c-2.7-22.4-13.4-47.7-51.5-47.7c-0.3,0-0.5,0-0.8,0v51.6l0,0
    C330.9,112.268,348.8,111.068,364,109.068z`,
        "aria-label": "Front left upper skull",
    },
    [bodyParts_1.BodyPartsFront.RightFace]: {
        d: `M302.5,174.668c1.1-1.5,5.1-2.5,6.6-1.4c0.732,0.537,1.654,0.713,2.5,0.71v-8.095c-1.035-0.049-2.246-0.388-3.8-1.215
    c-3.8,0.9-10-1.7-9.6-6.1c0.6-6.4,5-9.3,5.3-12.2s2.7-10.2,2.3-12.8c-0.4-2.5,0.6-9.9,5.5-9.9c0.102,0,0.2,0.014,0.3,0.02v-11.42
    c-0.1,0-0.2,0-0.3,0c-19,0-36.8-1.1-51.8-3.1c-0.9,8-1.1,17.1-1.1,27.4c0,2.2,0.1,4.4,0.2,6.5c0.5,11.2,2.3,22.2,4.6,31.6
    c3.2,13.1,7.4,23.3,10.5,26.9c3.5,5.3,9.4,9.8,13.8,13.2c6.8,5.3,13.2,8.3,22.6,8.9c0.5,0,1,0.1,1.5,0.1v-33.125
    c-6.7-0.246-8.514-2.519-10.5-3.276c-2.1-0.7-10.6-2-9.8-4.6C292,180.168,301.4,176.168,302.5,174.668z M287.6,139.468
    c-8,0-14.5-3.9-14.5-8.8c0-4.9,6.5-8.8,14.5-8.8s13.5,4,13.5,8.8C301.1,135.568,295.6,139.468,287.6,139.468z`,
        "aria-label": "Front right face",
    },
    [bodyParts_1.BodyPartsFront.LeftFace]: {
        d: `M364,109.068c-15.1,2-33.1,3.2-52.4,3.2v11.42c3.34,0.208,5.691,3.84,5.4,9.18c-0.3,5.5,2.4,7.5,2.9,12.6s4.6,7.2,4.6,11.4
    s-2.1,8-7.5,7.2c-1.941,0.803-3.304,1.914-5.4,1.815v8.095c0.887-0.004,1.69-0.205,2.1-0.41c1.5-0.7,5-1.7,7,0.7
    c3.2,3.9,11.8,7.5,11.5,9.4c-0.4,2.1-5.6,3.7-7.6,4.1c-2,0.5-4.1,2.9-11.8,2.9c-0.419,0-0.814-0.01-1.2-0.025v33.125
    c0.6,0,1.2,0,1.9,0c11.7,0,20.1-3.8,27.3-10.2c3.9-3.5,8.8-8.4,10.5-12.2c3.4-6.6,6.2-17.3,8.3-28c2.5-12.6,4.1-25.3,4.7-31.5
    c0.1-1.5,0.2-2.7,0.2-3.3C364.4,133.068,365.4,121.568,364,109.068z M336.4,139.468c-8,0-13.5-3.9-13.5-8.8c0-4.9,5.5-8.8,13.5-8.8
    s14.5,3.9,14.5,8.8C350.9,135.568,344.4,139.468,336.4,139.468z`,
        "aria-label": "Front left face",
    },
    [bodyParts_1.BodyPartsFront.RightEye]: {
        d: `M301.1,130.668c0-4.8-5.5-8.8-13.5-8.8s-14.5,3.9-14.5,8.8c0,4.9,6.5,8.8,14.5,8.8S301.1,135.568,301.1,130.668
    z`,
        "aria-label": "Right eye",
    },
    [bodyParts_1.BodyPartsFront.LeftEye]: {
        d: `M336.4,139.468c8,0,14.5-3.9,14.5-8.8s-6.5-8.8-14.5-8.8s-13.5,3.9-13.5,8.8
    C322.9,135.568,328.4,139.468,336.4,139.468z`,
        "aria-label": "Left eye",
    },
    [bodyParts_1.BodyPartsFront.RightEar]: {
        d: `M263.2,174.668c-2.3-9.4-4.1-20.4-4.6-31.6c-2.3-2.2-5.2-4.6-7.1-4.2c-2.9,0.6-4.1,8.2-3.1,13.6c1,5.4,3.9,14.2,6.5,18.8
    C257.2,175.368,259.7,180.868,263.2,174.668L263.2,174.668L263.2,174.668z`,
        "aria-label": "Right ear",
    },
    [bodyParts_1.BodyPartsFront.LeftEar]: {
        d: `M374.4,142.768c-0.5-4.7-4.8-4.9-6.5-2.2c-0.8,1.2-2.2,1.5-3.6,1.3c-0.6,6.2-2.2,18.9-4.7,31.5l0,0l0,0
    c2.4,5.3,5.4,2.8,6.6,0.9c1.5-2.4,4.4-8.9,5.8-12.6C373.4,157.968,374.9,147.468,374.4,142.768z`,
        "aria-label": "Left ear",
    },
    [bodyParts_1.BodyPartsFront.Nose]: {
        d: `M298.2,158.568c-0.4,4.4,5.8,7,9.6,6.1c4.7,2.5,6.3,0.6,9.2-0.6c5.4,0.8,7.5-3,7.5-7.2s-4.1-6.3-4.6-11.4
    s-3.2-7.1-2.9-12.6s-2.2-9.2-5.7-9.2c-4.9,0-5.9,7.4-5.5,9.9c0.4,2.6-2,9.9-2.3,12.8S298.8,152.168,298.2,158.568z`,
        "aria-label": "Nose",
    },
    [bodyParts_1.BodyPartsFront.Mouth]: {
        d: `M320.7,174.268c-2-2.4-5.5-1.4-7-0.7c-0.8,0.4-3.1,0.8-4.6-0.3s-5.5-0.1-6.6,1.4s-10.5,5.5-11.2,8.1
    c-0.8,2.6,7.7,3.9,9.8,4.6c2.1,0.8,4,3.3,11.7,3.3s9.8-2.4,11.8-2.9c2-0.4,7.2-2,7.6-4.1C332.5,181.768,323.9,178.168,320.7,174.268
    z`,
        "aria-label": "Mouth",
    },
    [bodyParts_1.BodyPartsFront.RightNeck]: {
        d: `M310.1,223.668L310.1,223.668c-9.4-0.6-15.8-3.6-22.6-8.9c-4.4-3.4-10.2-7.8-13.7-13.1c0.3,2.2,2.8,18.8,1.8,32.2
    c-0.9,13.4-10.8,16.6-31.6,20.6c-8.1,1.5-21.4,2.9-29.4,3.6c20.6,3.5,43.3,10.5,47.3,13.5v0.1c4,3,16.1,6.6,23.7,5.3
    s14,3.7,18.3,7.7c1.7,1.6,4.1,2.6,6.4,2.9c0.4,0.1,0.9,0.1,1.4,0.1v-63.9C311.1,223.668,310.6,223.668,310.1,223.668z`,
        "aria-label": "Front right neck",
    },
    [bodyParts_1.BodyPartsFront.LeftNeck]: {
        d: `M394,256.068c-17.5-1-39-4.6-42.5-13.3c-4.1-10-3.2-27.4-0.2-41.3l-0.1-0.1c-1.7,3.8-6.6,8.7-10.5,12.1
    c-7.2,6.4-15.6,10.2-27.3,10.2c-0.7,0-1.3,0-1.9,0v63.9c2.9,0,5.7-0.9,7.6-3c3.6-4,12-9.3,24.3-7.3s16.3-1,26.3-6
    c13.2-6.6,19.5-9.1,36.7-14.5C402.4,256.468,398.1,256.268,394,256.068z`,
        "aria-label": "Front left neck",
    },
    [bodyParts_1.BodyPartsFront.RightShoulder]: {
        d: `M267.2,274.368c-2.3-0.8-4.2-1.8-5.4-2.7v-0.1c-4-3-26.7-10-47.3-13.5c-8,0.7-36.8-0.8-45.5,44.5
    c-0.8,4.5-3.3,15.3-5.5,27.9c27-7.5,53.3,0.1,83.2,7.7c7-0.1,14.4,0.9,22,2.4C266.5,318.568,266,296.468,267.2,274.368z`,
        "aria-label": "Front right shoulder",
    },
    [bodyParts_1.BodyPartsFront.RightArm]: {
        d: `M163.5,330.468c-1.2,6.9-2.3,14.4-2.9,21.7l-0.1,0.2c-0.3,3-0.5,6-0.6,8.9c-0.7,20.9-17.8,65.6-22.8,82.6
    c2,21.5,38.6,20.6,48.6,11.7c0.8-2.1,1.6-4,2.2-5.3c2.3-5.2,15.8-39.8,16.7-50.7l0,0l0,0c-0.2-19.6,3.5-22.3,7-34.5
    c6.6-20.4,19.7-26.6,35.2-26.9C216.8,330.668,190.5,322.968,163.5,330.468z`,
        "aria-label": "Front right arm",
    },
    [bodyParts_1.BodyPartsFront.RightElbow]: {
        d: `M137.1,443.768c-0.4,1.3-0.7,2.4-0.9,3.4c-3.2,13.5-5.8,23.5-9.5,29.8c-1.3,2.2-4.4,8.4-8,16.7
    c8.2-10,21.6-12.3,31.8-7.8c10.5,4.6,18.2,17.6,19.5,33.8c0.4-1.7,0.7-3.2,1-4.4c1.7-9.5,6.5-29,8-37.7c1.1-6.5,4.3-15.7,6.8-22.1
    C175.8,464.268,139.1,465.268,137.1,443.768z`,
        "aria-label": "Front right elbow",
    },
    [bodyParts_1.BodyPartsFront.RightForearm]: {
        d: `M150.5,485.768c-10.1-4.5-23.5-2.2-31.8,7.8c-6.3,14.9-14.1,37-16,56.5c-4.4,44.5-10.9,61.2-15.9,74.5
    c1.8,4.4,7.2,6.7,12.4,8.9c5.5,2.4,14.8,4.1,20,3.2c2-4.5,4.3-9.3,6.5-13.4c8.5-15.2,21.8-43.4,28.8-59.1
    c6.1-13.6,12.8-33.5,15.5-44.7C168.7,503.368,161,490.368,150.5,485.768z`,
        "aria-label": "Front right forearm",
    },
    [bodyParts_1.BodyPartsFront.RightWrist]: {
        d: `M99.2,633.568c-5.2-2.2-10.6-4.6-12.4-8.9c-0.7,1.8-1.3,3.6-2,5.3c-2.7,7.8-5.6,12.2-8.2,14.7
    c6.8-0.8,13.8,1.3,19.6,4.9c6.2,3.9,11.6,4.6,13.3,9.8c1-3.5,3.6-9.5,7-16.8c0.8-1.8,1.7-3.8,2.6-5.8
    C113.9,637.668,104.7,635.968,99.2,633.568z`,
        "aria-label": "Front right wrist",
    },
    [bodyParts_1.BodyPartsFront.RightHand]: {
        d: `M96.3,649.568c-5.8-3.6-12.8-5.7-19.6-4.9c-2.2,2.2-4.1,3-5.5,3.4c-2.9,1-20.6,11.6-26.4,15.2
    s-8.6,9.4-14.2,12.1s-8.5,6.9-10,8.6s-6.6,7.5-6.6,9.9s4.4,3.8,8,2.9s11.8-8.6,15.8-12.4s9.5-4.9,12.2-4.9s2.6,3.1,1.9,4.5
    s-2.9,8.2-4,13.6s-1,11.9-1.9,14s-5,19.4-5.6,23.6s-2.6,15.5,0,19s6,1.2,7.1-1.4s3.6-14.1,4.1-16.9s6.8-21.1,7.4-22.8
    s3.1,2.6,2.2,5.8s-2.4,11.8-4.8,18.5s-2.6,14.1-3.4,17.5s-1.8,8.1-1.5,11.5s3.1,5.9,5.5,4.6s4.9-9.5,5.5-12.5s4-14.4,5.6-18.4
    s3-20.5,4-23s1.9,1.1,1.2,2.8s-3.4,18-3.8,21.6s-3.5,14.9-2.6,19.1s5.1,3.5,6.8,1.8s2.5-7.1,3-9.8s4.1-13.4,5.4-17.5
    s3.4-16.2,4.1-20.2s2-1.6,1.1,1.8s-0.9,11.9-1.8,14.2s-1,8.1-1.8,9.6s-2.8,5.9-1,9s5,1.5,5.9,0.1s3.8-10.6,5-13.4s2.6-11,3.8-15.9
    s3.2-11,4.4-17.5s1.3-14,2.5-18.3s4.5-18.7,4.7-23c0-0.6,0.2-1.4,0.5-2.4C107.9,654.168,102.5,653.568,96.3,649.568z`,
        "aria-label": "Front right hand",
    },
    [bodyParts_1.BodyPartsFront.LeftShoulder]: {
        d: `M445.5,275.468c-10.7-15-25-17.7-39-18.6c-17.2,5.4-23.5,7.9-36.7,14.5c-4.6,2.3-7.9,4.2-11.4,5.3c1,21.4,0.4,42.9-1.8,64.3
    c0.9-0.2,1.8-0.4,2.7-0.5c0.1,0,0.2,0,0.4-0.1c1.2-0.2,2.4-0.4,3.5-0.6c0.1,0,0.3,0,0.4-0.1c1.2-0.2,2.3-0.4,3.5-0.5
    c0.1,0,0.3,0,0.4-0.1c1.2-0.2,2.3-0.3,3.5-0.4c0.1,0,0.2,0,0.3,0c1.2-0.1,2.3-0.2,3.5-0.3c0.1,0,0.1,0,0.2,0
    c1.2-0.1,2.4-0.1,3.6-0.1c30.1-7.4,56.5-14.9,83.4-7.5C459.2,311.968,454,287.268,445.5,275.468z`,
        "aria-label": "Front left shoulder",
    },
    [bodyParts_1.BodyPartsFront.LeftArm]: {
        d: `M487.6,443.168c-0.2-0.8-0.4-1.6-0.6-2.4c-2.2-8.3-5.5-19.7-10.5-34.4c-3.7-11.1-6.3-20.3-8.2-27.7c-1.2-4.8-2-8.8-2.6-12.2
    c-1-5.8-1.3-9.6-1.3-11.8h0.1c0-2.2-0.8-11.8-2.5-23.9c-26.9-7.4-53.3,0.1-83.4,7.5c15.2,0,28.1,5.4,35,24.4
    c3.5,9.2,8.5,18.3,6,38.5c0,0.1,0,0.2,0,0.3l0,0c0.5,1.8,1.8,4,2.6,6.5c0.9,2.8,7.3,22.7,10.3,30.8c1.4,3.7,3.6,8.7,5.8,13.7
    C443.3,464.968,494.8,474.668,487.6,443.168z`,
        "aria-label": "Front left arm",
    },
    [bodyParts_1.BodyPartsFront.LeftElbow]: {
        d: `M474.8,485.768c11.7-5.2,25.5-5.1,32.1,9.9c-1.4-3.3-2.7-6.2-3.9-8.8c-1.1-2.4-2.2-4.5-3.1-6.2
    c-6.2-11.8-8-20-9-23.8c-0.5-1.8-1.4-6.3-3.4-13.7c7.3,31.5-44.3,21.8-49.1,9.4c2.6,6.1,5.1,12.2,5.9,16.3
    c0.9,4.9,2.8,15.8,4.5,21.3c0.8,2.8,2.1,9.8,3.5,17c1.4,7,2.8,14.2,4.2,17.7C451.8,504.068,462,491.468,474.8,485.768z`,
        "aria-label": "Front left elbow",
    },
    [bodyParts_1.BodyPartsFront.LeftForearm]: {
        d: `M526.1,633.568c5.1-2.2,10.5-4.5,12.3-8.8c-0.2-0.5-0.4-0.9-0.5-1.4c-6.5-17-11.5-47.2-15-73.2
    c-2.5-18.3-9.8-39.5-16-54.5c-6.6-14.9-20.4-15-32.1-9.9c-12.8,5.7-23,18.2-18.3,39c2.7,7,11,35,20,52c7.5,14.1,23.8,47.3,29.8,60
    C511.5,637.668,520.7,635.968,526.1,633.568z`,
        "aria-label": "Front left forearm",
    },
    [bodyParts_1.BodyPartsFront.LeftWrist]: {
        d: `M529,649.568c7.8-4.9,17.8-7,26.6-3c-9.1-4.7-11.1-6.2-17.1-21.9c-1.8,4.3-7.2,6.6-12.3,8.8
    c-5.5,2.4-14.7,4.1-19.9,3.2c1.2,2.6,2,4.3,2.2,4.8c1.2,3.2,5.6,12.8,5.8,15.5c0.1,1.2,0.5,4.7,1.1,9
    C513.9,654.268,520.8,654.768,529,649.568z`,
        "aria-label": "Front left wrist",
    },
    [bodyParts_1.BodyPartsFront.LeftHand]: {
        d: `M599.8,676.768c-3.3-5.2-13.7-10-17-13.5s-17.8-11.8-27.2-16.7c-8.8-4-18.8-1.9-26.6,3
    c-8.3,5.2-15.1,4.7-13.7,16.5c0.8,5.3,2,11.9,3.3,17.2c2.4,9.8,2.1,16.2,3.5,22.4c1.4,6.1,4.9,14.5,5.8,21.2s3.4,7.2,5.5,15.2
    s6.9,8.4,8.1,6.1s0.4-7.5-0.4-8.5s-1.5-3.1-1.9-5.2s-1.6-8.4-2.1-11.5s-3.1-13.1-2.2-14.5s3.5,4,3.8,5.9s3,14.9,5,21.2
    s4,18.5,7.1,22.9s7.1,1.1,7.1-2.9s-3-17.1-3.2-20s-3.9-20-4.4-21.6s2.5-1.1,2.8,0.2s1.8,10.6,3,14.4s5,18.1,5.5,20.8
    s2,14.1,6.1,16.2s5.9-2.1,6.2-5.9s-5.5-30-6.4-34.5s-4.4-16.9-3-18.1c1.4-1.2,4.9,11.8,5.5,15.8s4.4,22.9,5.9,26.6s5.8,4.8,7.5,1.5
    s-1.5-24.4-1.9-31.4s-4.4-14.2-4.5-21.2s-5.2-20.5-4.8-22.7c0.5-2.6,9.2,0.3,12.2,2.7c3,2.3,8.5,8.5,11.5,10s8.8,3.8,10.2,0
    S603.1,681.968,599.8,676.768z`,
        "aria-label": "Front left hand",
    },
    [bodyParts_1.BodyPartsFront.UpperSternum]: {
        d: `M358.4,276.668c-4.1,1.4-8.3,1.8-14.9,0.7c-12.3-2-20.7,3.3-24.3,7.3c-2.2,2.4-5.7,3.3-9,2.9c-2.3-0.3-4.7-1.3-6.4-2.9
    c-4.3-4-10.7-9-18.3-7.7c-5.4,0.9-12.9-0.6-18.3-2.6c-1.2,22.1-0.6,44.2,1.6,66.3c6.2,1.2,12.6,2.7,18.8,4.1c0.1,0,0.2,0,0.3,0.1
    c0.4,0.1,0.7,0.2,1.1,0.2c0.3,0.1,0.6,0.1,1,0.2c0.3,0.1,0.6,0.1,0.9,0.2c0.4,0.1,0.8,0.2,1.2,0.3c0.2,0.1,0.5,0.1,0.7,0.2
    c0.5,0.1,0.9,0.2,1.3,0.3c0.2,0,0.4,0.1,0.6,0.1c0.5,0.1,1,0.2,1.6,0.3c0.1,0,0.3,0.1,0.4,0.1c2,0.4,4,0.7,5.9,1c0.1,0,0.1,0,0.2,0
    c0.6,0.1,1.1,0.2,1.7,0.2c0.1,0,0.2,0,0.4,0c0.5,0.1,1,0.1,1.5,0.2c0.1,0,0.3,0,0.4,0c0.5,0.1,1,0.1,1.5,0.2c0.1,0,0.3,0,0.4,0
    c0.5,0,1,0.1,1.5,0.1c0.1,0,0.2,0,0.3,0c0.6,0,1.2,0.1,1.8,0.1l0,0c0.1,0,0.1,0,0.2,0c1.4,0,2.7-0.1,4-0.1
    c10.1-0.6,21.1-3.3,32.1-5.8c0.7-0.2,1.4-0.3,2.1-0.5c0.4-0.1,0.8-0.2,1.1-0.3c1.2-0.3,2.3-0.5,3.5-0.7c0.2,0,0.3-0.1,0.5-0.1
    c0.3-0.1,0.6-0.1,0.9-0.2C358.8,319.568,359.4,298.168,358.4,276.668z`,
        "aria-label": "Front upper sternum",
    },
    [bodyParts_1.BodyPartsFront.LowerSternum]: {
        d: `M333.4,361.168c0.3-5.1,0.7-10.2,1.1-15.3c-7.7,1.6-15.2,2.8-22.1,2.8c-7.1-0.3-14.8-1.7-22.7-3.4
    c0.4,5.3,0.8,10.6,1.1,15.9c1,16.7,1.6,33.3,1.7,49.9l0,0c5.6-3.2,11.6-5.5,17.6-6v0.1c0.8-0.1,1.5-0.1,2.3-0.1
    c6.7,0,12.9,2.4,19.3,6.5c0-0.2,0-0.3,0-0.5C331.8,394.468,332.4,377.768,333.4,361.168z`,
        "aria-label": "Front lower sternum",
    },
    [bodyParts_1.BodyPartsFront.Epigastric]: {
        d: `M332.2,451.068c-0.2-5.6-0.3-11.3-0.4-17c-0.1-7.5-0.2-15-0.1-22.5l0,0v0c-6.4-4.2-12.6-6.5-19.4-6.5c-0.8,0-1.5,0-2.3,0.1
    v-0.1c-5.9,0.5-12,2.9-17.6,6c0.1,7.7,0,15.3-0.1,23c-0.1,5.7-0.2,11.4-0.4,17c-0.3,8.6-0.7,17.2-1.2,25.7
    c5.8-2.2,12.1-3.8,19.3-4.1c0.8,0,1.5-0.1,2.3-0.1c7.7,0,14.8,1.6,21,3.9c-0.014-0.233-0.028-0.502-0.043-0.795
    C332.785,467.444,332.491,459.302,332.2,451.068z`,
        "aria-label": "Front epigastric",
    },
    [bodyParts_1.BodyPartsFront.RightRibs]: {
        d: `M292.5,411.068c-0.1-16.6-0.7-33.3-1.7-49.9c-0.3-5.3-0.7-10.6-1.1-15.9c-31.2-6.8-65.7-18.2-78.1,19.8
    c-3.5,12.2-7.2,14.9-7,34.5c1.2,8,5.1,16.8,8.9,21.2c0.039,0.049,0.078,0.095,0.116,0.144c0.542,5.045,3.603,20.234,5.684,28.656
    c0.5,2.3,1,4,1.3,5c0.5,1.5,1.2,8.1,1.9,16.8c2.3,4,7.4,32.3,48.8,14.2c6.3-2.7,12.6-6.1,19.7-8.8c0.5-8.5,0.9-17.1,1.2-25.7
    c0.1-5.6,0.2-11.3,0.3-17c0.1-7.6,0.1-15.3,0.1-23H292.5z`,
        "aria-label": "Front right ribs",
    },
    [bodyParts_1.BodyPartsFront.LeftRibs]: {
        d: `M413.6,362.668c-13.2-36.1-47.8-23.3-79.1-16.8c-0.4,5.1-0.8,10.2-1.1,15.3c-1,16.7-1.6,33.3-1.7,49.9c0,0.2,0,0.3,0,0.5
    l0,0c-0.1,7.5,0,15,0.1,22.5c0.1,5.7,0.2,11.4,0.4,17c0.3,8.5,0.6,16.9,1.1,25.4c7.7,2.9,14.5,6.7,20.4,9.4
    c39.9,18,46.9-6.8,49.9-16.5c0.9-10.1,1.7-17.7,2-18.8c0.996-3.385,5.163-24.214,5.791-30.119c3.293-4.088,7.813-14.92,8.209-19.281
    C422.1,380.968,417.1,371.868,413.6,362.668z`,
        "aria-label": "Front left ribs",
    },
    [bodyParts_1.BodyPartsFront.Umbilical]: {
        d: `M340.7,551.068c-2.6-18.9-4.7-37.9-6.2-57.1l0,0c-0.5-5.8-0.8-11.6-1.2-17.5c-6.3-2.3-13.2-4.1-20.9-4.1
    c-0.8,0-1.5,0-2.3,0.1c-7.2,0.3-13.4,2-19.2,4.2c-0.3,5.8-0.7,11.5-1.2,17.2l0,0c-1.5,18.9-3.5,37.8-6.1,56.5
    C302.6,551.968,321.7,552.168,340.7,551.068z`,
        "aria-label": "Front umbilical",
    },
    [bodyParts_1.BodyPartsFront.Pelvis]: {
        d: `M353.5,622.268L353.5,622.268c-4.1-18.5-7.6-37.1-10.5-55.9c-0.8-5.1-1.5-10.2-2.3-15.3c-19.1,1.1-38.1,0.9-57.2-0.6
    c-0.7,5.3-1.5,10.6-2.3,15.9c-2.9,18.8-6.5,37.4-10.5,55.9l0,0C309.9,632.068,321.4,632.268,353.5,622.268z`,
        "aria-label": "Front pelvis",
    },
    [bodyParts_1.BodyPartsFront.Pubis]: {
        d: `M270.7,622.268c16.5,28.4,29.1,60.3,35.1,89.1c1.5,0.5,2.9,0.9,4.3,1.1c2.8,0.4,5.6,0,8.3-0.8c6-28.9,18.6-60.9,35.2-89.4
    C321.4,632.268,309.9,632.068,270.7,622.268z`,
        "aria-label": "Front pubis",
    },
    [bodyParts_1.BodyPartsFront.RightLumbar]: {
        d: `M270.7,622.268c4.1-18.4,7.6-37.1,10.5-55.9c3.7-23.9,6.6-48,8.5-72.4l0,0c0.4-5.7,0.8-11.5,1.2-17.2
    c-7,2.7-13.4,6.1-19.7,8.9c-41.4,18.1-46.6-10.2-48.8-14.2c1.6,19.3,3.1,49,2.1,56.2c-0.8,5.7-5.2,17.6-9.7,28.8
    C235.6,571.468,254.9,595.268,270.7,622.268z`,
        "aria-label": "Front right lumbar",
    },
    [bodyParts_1.BodyPartsFront.LeftLumbar]: {
        d: `M410.6,555.568c-0.2-0.5-0.3-0.9-0.4-1.2c-1.2-3.8-6.8-17-9.2-23.2c-1.7-4.3,0.6-39.4,2.5-61.9c-3.1,9.7-10,34.5-50,16.5
    c-5.9-2.6-12.5-6.5-20.2-9.3c0.3,5.8,0.7,11.8,1.2,17.6l0,0c1.9,24.3,4.7,48.5,8.5,72.4c3,18.8,6.5,37.5,10.5,55.9
    C369.6,594.668,389.4,570.468,410.6,555.568z`,
        "aria-label": "Front left lumbar",
    },
    [bodyParts_1.BodyPartsFront.RightCrotch]: {
        d: `M270.7,622.268L270.7,622.268c-15.7-27-35.1-50.8-55.9-65.8c-1.8,4.5-3.6,8.8-5.1,12.7c-1.8,4.3-3.4,7.9-4.3,10.2
    c-0.7,1.8-4.8,12.2-9.3,28.1c15.1,4.1,43.2,30.5,64.9,54.3c8.3,9.1,15.7,17.9,21.1,24.9h0.1c5.7,7.5,9.6,13,10.4,14.8
    c4.5,5.1,8.9,8.3,13.2,9.9C299.8,682.568,287.2,650.668,270.7,622.268z`,
        "aria-label": "Front right crotch",
    },
    [bodyParts_1.BodyPartsFront.RightThigh]: {
        d: `M196.2,607.468c-8.9,31.5-19.8,84.9-10.4,137.2c1.9,10.7,29.7,157,32.4,171.8c0.4,2.4,1.2,5.8,2,10
    c54.8-4.2,72.9,49.1,80.7,10.1c-0.3-28.3-1.7-73.1-2.7-91.6c-0.5-9-1.7-28.9,3.6-60.6c2.4-14.4,13.4-54.9-9.2-82.8
    c-0.8-1.8-4.7-7.3-10.4-14.8C262.8,661.368,217.1,613.168,196.2,607.468z`,
        "aria-label": "Front right thigh",
    },
    [bodyParts_1.BodyPartsFront.RightKnee]: {
        d: `M220.2,926.368c3.1,15.3,8,40.6,8.2,61.1c9.9,48.1,49,36.4,64.3,13.9c0.2-1.7,0.6-3.2,1-4.5
    c3.2-9.2,7-21.2,7.2-44c0-4.3,0-9.9-0.1-16.4C293.1,975.568,275,922.268,220.2,926.368z`,
        "aria-label": "Front right knee",
    },
    [bodyParts_1.BodyPartsFront.RightLeg]: {
        d: `M228.4,987.468c0.1,8.4-0.7,15.9-2.7,21.7c-9.5,27-3.2,94.8,0,112s21.2,99.8,24.1,121.5c0.3,2.2,0.4,4.6,0.5,7
    c7-6.9,20.7-9.9,28.9-8.1c5,1.1,8.3,3.6,11.1,7.5c-2.4-9.7-1.7-19.7-1-34.9c0.8-16.5,6.8-83.5,9.8-105.2s0.8-46.2-2.5-62
    c-2.8-13.7-5.3-34.2-3.7-45.5C277.4,1023.868,238.3,1035.468,228.4,987.468z`,
        "aria-label": "Front right leg",
    },
    [bodyParts_1.BodyPartsFront.RightAnkle]: {
        d: `M279.1,1241.568c-8.2-1.8-21.8,1.2-28.9,8.1c0.2,11-1.6,22.9,0.2,29c1.6,5.6,2.3,5.9,1.3,9.8
    c7.5-4.4,35.3-5.7,42.3,2.9c-0.6-3.5-1.6-7-2.3-9.5c-1.2-4.5,0.2-8.8,1.8-11.2s0.8-8.5-2.5-19c-0.3-0.9-0.5-1.8-0.7-2.6
    C287.4,1245.168,284.1,1242.668,279.1,1241.568z`,
        "aria-label": "Front right ankle",
    },
    [bodyParts_1.BodyPartsFront.RightForefoot]: {
        d: `M251.8,1288.468c-0.3,1.3-0.9,3.1-1.6,5.7c-3,10-9.3,16.8-12.5,22s-0.5,7.8,2.8,9.7c3.3,1.8,3.3-0.5,4.8,0.7
    s12.3,0.5,13.5,0.2s1.5-0.7,5.2,0.8s8.8-2.3,10.7-0.7s10,1.7,12.7,1.4s5.3-5.2,5.8-6.7s0.3-3,1-5s1.2-6.2-0.2-9
    c-1.3-2.8-1.5-3.3,0-8.3c0.7-2.2,0.5-5,0.1-7.7C287,1282.768,259.3,1284.068,251.8,1288.468z`,
        "aria-label": "Right forefoot",
    },
    [bodyParts_1.BodyPartsFront.LeftCrotch]: {
        d: `M353.5,622.268L353.5,622.268c-16.6,28.5-29.2,60.5-35.2,89.4c5.3-1.7,10.3-5.7,15.1-11c0.8-1.7,4.1-7.2,9.1-14.6l0,0l0,0
    c4.9-7.4,11.9-16.8,20-26.5c19.2-22.9,44.8-47.6,65.5-52.1c-4.8-18.7-9.2-31.6-10.2-33.3c-0.7-1.3-1.5-3.1-2.3-5l0,0
    c-1.9-4.7-3.9-10.3-5-13.6C389.4,570.468,369.6,594.668,353.5,622.268L353.5,622.268z`,
        "aria-label": "Front left crotch",
    },
    [bodyParts_1.BodyPartsFront.LeftThigh]: {
        d: `M342.5,685.968c-5,7.5-8.2,12.9-9.1,14.6c-22,24.2-15.5,60.2-10.5,83.7s4,49.2,3.8,59.5
    c-0.2,7.9-2.7,56.3-3,88.5c7.5,47.2,22.3-11.8,80.6-5.8c0.6-3.9,1.3-7.7,1.9-11.3c1.7-9.7,18-92.7,21-108.7s14.6-62.2,14.6-105.2
    c0-32.7-7.1-68.6-13.6-94C398.7,613.868,359.1,661.168,342.5,685.968z`,
        "aria-label": "Front left thigh",
    },
    [bodyParts_1.BodyPartsFront.LeftKnee]: {
        d: `M323.7,932.368c-0.1,9.7,0,18,0.4,23.2c1.8,22.5,4.2,31.7,7.7,44.5c15.2,24,59.7,38.5,64.9-16
    c0-11.8,2.1-30.8,4.1-39.2c1.3-5.2,2.4-11.8,3.5-18.4C345.9,920.668,331.2,979.668,323.7,932.368z`,
        "aria-label": "Front left knee",
    },
    [bodyParts_1.BodyPartsFront.LeftLeg]: {
        d: `M331.8,1000.168c3.5,12.8-5.2,55.3-7,75.2c-1.8,19.8,5,54.5,5.2,66.3s3.2,42.5,4.8,56.8
    c1.7,14.3,2.3,41.2-0.7,53.5c3.3-5.5,5.9-9.1,12.1-10.4c8.8-1.9,21.8,0.7,28.3,8.6c0.5-9.5,5.2-38.2,14.8-79.2s12.8-69.8,14.5-100.5
    s-0.5-49.8-2.2-55s-4.8-19.5-4.8-31.2C391.4,1038.668,346.9,1024.168,331.8,1000.168z`,
        "aria-label": "Front left leg",
    },
    [bodyParts_1.BodyPartsFront.LeftAnkle]: {
        d: `M346.2,1241.568c-6.2,1.3-8.8,4.9-12.1,10.4c-3,12.3-3.2,15.2-1.2,22.3c2,7.2,0,8.5-1.8,18
    c4.7-11.7,38.2-9.3,42-3.5c-1.7-4.3,0.5-5.5,1.8-12.5s-1-16.7-0.5-26.2C368,1242.168,355,1239.568,346.2,1241.568z`,
        "aria-label": "Front left ankle",
    },
    [bodyParts_1.BodyPartsFront.LeftForefoot]: {
        d: `M331.1,1292.268c-1.8,9.5,2.7,9.8,0.3,14.2c-2.3,4.3-1.3,10.5-0.2,11.5s-1.3,2.5,3,7.2s13.8,2.7,15.3,2.2
    s3-1,4,0.2s6.5,0.6,7.7,0s3.3-1.2,4-0.3s5.2-0.4,7.5,0s5.8-1.2,8.2-0.8c2.3,0.3,7.2-2,7-6.5s-2.8-6.2-4.8-9.2s-8.3-17.5-10-21.8
    C369.3,1283.068,335.8,1280.668,331.1,1292.268z`,
        "aria-label": "Left forefoot",
    },
};
const FrontFemaleBodyParts = (props) => {
    return react_1.default.createElement(BodyParts_1.BodyParts, Object.assign({ image: react_1.default.createElement(FemaleImage_1.default, { href: female_front_png_1.default }), paths: paths }, props));
};
exports.default = FrontFemaleBodyParts;
//# sourceMappingURL=FrontFemaleBodyParts.js.map